/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RiskTreatmentActionUpdate = {
    readonly uuid?: string;
    title: string;
    owner: string;
    deadline: string;
    description: string;
    risks: Array<string>;
    status?: RiskTreatmentActionUpdate.status;
    type?: RiskTreatmentActionUpdate.type;
}

export namespace RiskTreatmentActionUpdate {

    export enum status {
        PLANNED = 'planned',
        PROGRESS = 'progress',
        IMPLEMENTED = 'implemented',
    }

    export enum type {
        FULL = 'full',
        IMPROVEMENT = 'improvement',
    }


}
